/**
 * 落地页广场列表预取（LCP 优化）。
 *
 * 原为 prerender 注入的内联脚本（HTML 解析期发 fetch）；为满足 CSP
 * script-src 不含 'unsafe-inline'（安全评估 MED-02）先迁为外部阻塞脚本、
 * 再因解析阻塞引入额外网络往返而改为当前方案：
 * - prerender 在落地页注入 `<link rel="preload" as="fetch"
 *   href="/api/plaza?sort=popular&limit=8">`（预加载扫描器在 HTML 解析期
 *   即发起请求，不阻塞解析——比原内联脚本更早且零渲染代价）；
 * - 本模块在 bundle 求值期发同一 URL 的 fetch 消费 preload 缓存（首访
 *   网络早已在途，等效原时序），把 promise 写入 window 信封。
 *
 * lib/api.ts 的 listPlaza 按 query 一次性消费；失败/未命中回落常规请求。
 * ⚠ URL 与 query 必须与 prerender.mjs 的 preload link 逐字一致
 * （sort → limit），改动任一侧必须同步另一侧。
 */

const PLAZA_PREFETCH_QUERY = "sort=popular&limit=8";

(function bootPlazaPrefetch(): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as {
    __TSUVI_PLAZA_LIST_PREFETCH__?: {
      query: string;
      promise: Promise<unknown>;
    } | null;
  };
  try {
    w.__TSUVI_PLAZA_LIST_PREFETCH__ = {
      query: PLAZA_PREFETCH_QUERY,
      promise: fetch(`/api/plaza?${PLAZA_PREFETCH_QUERY}`, {
        headers: { accept: "application/json" },
      })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null),
    };
  } catch {
    w.__TSUVI_PLAZA_LIST_PREFETCH__ = null;
  }
})();
